// extracted by mini-css-extract-plugin
export default {"formContainer":"Search_formContainer__ihQxn","searchInput":"Search_searchInput__Qk-44","searchButton":"Search_searchButton__8Jp1t"};